import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { history } from '../store';

// react-router v6 removed the `withRouter` HOC. This shim restores it for our class
// components, injecting v6 hook values shaped to match the v5 router props those
// components were written against:
//   - match: { params, url, path } — url/path are the current pathname, which covers
//     our only non-param callsites (a couple of `match.url === '/x'` checks and one
//     `match.path.split('/')[2] === 'edit'`; pathname gives the same result there).
//   - location: the v6 location object (has pathname/search/state/hash).
//   - navigate: the v6 navigate fn, for any new imperative navigation.
//   - history: the app's history singleton, kept so existing `this.props.history` /
//     prop-drilled history stays valid (most code imports the singleton directly).
const withRouter = (Component) => {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const match = { params, url: location.pathname, path: location.pathname };

    return (
      <Component
        {...props}
        match={match}
        location={location}
        navigate={navigate}
        history={history}
      />
    );
  }

  return ComponentWithRouterProp;
};

export default withRouter;
